import { render, staticRenderFns } from "./SharedIds.vue?vue&type=template&id=52677773&scoped=true&"
import script from "./SharedIds.vue?vue&type=script&lang=js&"
export * from "./SharedIds.vue?vue&type=script&lang=js&"
import style0 from "./SharedIds.vue?vue&type=style&index=0&id=52677773&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52677773",
  null
  
)

export default component.exports